(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["phonecbd-faq-modern"]) return;
  try {
    
(() => {
  const setup = root => {
    if (root.dataset.searchReady) return;
    root.dataset.searchReady = 'true';
    const input = root.querySelector('#pcbFaqSearch');
    const empty = root.querySelector('#pcbFaqEmpty');
    const status = root.querySelector('#pcbFaqResults');
    const clear = root.querySelector('[data-faq-clear]');
    const categories = [...root.querySelectorAll('.pcb-faq__category')];
    const items = [...root.querySelectorAll('.pcb-faq__item')];
    const initial = new Map();
    let searching = false;
    const clean = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const update = () => {
      const query = clean(input.value.trim());
      if (query && !searching) items.forEach(item => initial.set(item, item.open));
      let count = 0;
      items.forEach(item => {
        const visible = !query || clean(item.textContent).includes(query);
        item.hidden = !visible;
        if (visible) count++;
        if (query && visible) item.open = true;
        if (!query && searching) item.open = initial.get(item) || false;
      });
      categories.forEach(category => { category.hidden = ![...category.querySelectorAll('.pcb-faq__item')].some(item => !item.hidden); });
      clear.hidden = !query;
      empty.hidden = count !== 0;
      status.textContent = query ? status.dataset.resultLabel.replace('[count]', String(count)) : '';
      searching = Boolean(query);
    };
    input.addEventListener('input', update);
    clear.addEventListener('click', () => { input.value = ''; update(); input.focus(); });
    root.querySelectorAll('.pcb-faq__quick a').forEach(link => link.addEventListener('click', () => { input.value = ''; update(); }));
    items.forEach(item => {
      const sync = () => { const icon = item.querySelector('summary b'); if (icon) { icon.textContent = item.open ? '−' : '+'; icon.setAttribute('aria-hidden', 'true'); } };
      item.addEventListener('toggle', sync);
      sync();
    });
  };
  const init = () => document.querySelectorAll('.pcb-faq').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["phonecbd-site-header"]) return;
  try {
    
(() => {
  const setup = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    const mobile = root.querySelector('[data-pcb-mobile-nav]');
    const close = root.querySelector('[data-pcb-nav-close]');
    const groups = [...root.querySelectorAll('[data-pcb-nav-group]')];
    const closeMenus = restore => {
      const wasOpen = mobile.open;
      mobile.open = false;
      groups.forEach(group => { group.open = false; });
      if (restore && wasOpen) mobile.querySelector('summary').focus();
    };
    close.hidden = false;
    close.addEventListener('click', () => closeMenus(true));
    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const group = event.target.closest('[data-pcb-nav-group][open]');
      if (group) { group.open = false; group.querySelector('summary').focus(); }
      else closeMenus(true);
    });
    root.addEventListener('click', event => {
      const summary = event.target.closest('[data-pcb-nav-group]>summary');
      if (summary) groups.forEach(group => { if (group !== summary.parentElement) group.open = false; });
    });
    document.addEventListener('click', event => { if (!root.contains(event.target)) closeMenus(false); }, {signal});
    document.addEventListener('focusin', event => { if (!root.contains(event.target)) closeMenus(false); }, {signal});
    window.matchMedia('(min-width:1051px)').addEventListener('change', () => closeMenus(false), {signal});
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) controller.abort(); }, {signal});
  };
  const init = () => document.querySelectorAll('[data-pcb-site-header]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["repair-collection"]) return;
  try {
    
(() => {
  function initialize(section) {
    if (section.dataset.initialized === 'true') return;
    const api = window.PCBRepair;
    const input = section.querySelector('[data-model-search]');
    const grid = section.querySelector('[data-model-list]');
    const result = section.querySelector('[data-search-result]');
    const clear = section.querySelector('[data-clear-search]');
    const empty = section.querySelector('[data-empty-state]');
    const pagination = section.querySelector('[data-pagination]');
    const help = section.querySelector('[data-pcb-help-link]');
    if (!api || !input || !grid || !result || !clear) return;
    section.dataset.initialized = 'true';
    const initial = Array.from(grid.children).map(node => node.cloneNode(true));
    let catalogue = null;
    let generation = 0;
    let timer;
    const mac = section.dataset.deviceFamily === 'mac';
    function card(item) {
      const li = document.createElement('li');
      li.className = 'repair-models__item';
      li.dataset.model = item.title;
      li.dataset.productUrl = item.url;
      const link = document.createElement('a');
      link.className = 'repair-models__card';
      link.href = item.url;
      link.setAttribute('aria-label', item.title);
      const wrap = document.createElement('span');
      wrap.className = 'repair-models__image-wrap';
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.width = 450;
        img.height = 450;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = item.title;
        img.className = 'repair-models__image';
        wrap.append(img);
      }
      const name = document.createElement('strong');
      name.className = 'repair-models__name';
      name.textContent = item.title;
      link.append(wrap, name);
      if (section.dataset.showPrice === 'true') {
        const price = document.createElement('span');
        price.className = 'repair-models__price';
        price.textContent = item.price_label ? api.text('from') + ' ' + item.price_label : api.text('quote');
        link.append(price);
      }
      const arrow = document.createElement('span');
      arrow.className = 'repair-models__arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      link.append(arrow);
      li.append(link);
      return li;
    }
    function show(query, limited = false) {
      const useCatalogue = catalogue && (Boolean(query) || mac);
      const nodes = useCatalogue ? catalogue.map(card) : initial.map(node => node.cloneNode(true));
      const matches = nodes.filter(node => api.matches(node.dataset.model, query));
      grid.replaceChildren(...matches);
      if (empty) empty.hidden = matches.length > 0 || !query;
      if (pagination) pagination.hidden = !limited && (Boolean(query) || (mac && Boolean(catalogue)));
      result.textContent = query || (mac && catalogue)
        ? section.dataset.resultsLabel.replace('__COUNT__', String(matches.length)) : '';
      if (limited) result.textContent += ' — ' + section.dataset.limitedLabel;
      clear.hidden = !query;
      if (help) {
        const family = section.querySelector('.repair-models__title')?.textContent.trim();
        help.href = api.whatsapp([api.text('helpMessage'), family, input.value.trim()].filter(Boolean).join(' — '));
      }
    }
    async function search() {
      const version = ++generation;
      const query = input.value.trim();
      if (!query && !mac) { show(''); return; }
      if (catalogue) { show(query); return; }
      show(query);
      result.textContent = section.dataset.loadingLabel;
      grid.setAttribute('aria-busy', 'true');
      try {
        const items = await api.loadModels(section.dataset.collectionUrl);
        if (version !== generation) return;
        catalogue = items;
        show(input.value.trim());
      } catch (_) {
        if (version !== generation) return;
        show(input.value.trim(), true);
      } finally {
        if (version === generation) grid.removeAttribute('aria-busy');
      }
    }
    function onSearchInput() {
      clearTimeout(timer);
      generation += 1;
      grid.removeAttribute('aria-busy');
      clear.hidden = !input.value;
      if (!input.value.trim()) { show(''); return; }
      show(input.value.trim());
      timer = setTimeout(search, 180);
    }
    input.addEventListener('input', onSearchInput);
    input.addEventListener('search', onSearchInput);
    clear.addEventListener('click', () => {
      clearTimeout(timer);
      generation += 1;
      grid.removeAttribute('aria-busy');
      input.value = '';
      show('');
      input.focus();
    });
    if (mac || input.value.trim()) search();
  }
  function initializeAll(root = document) {
    root.querySelectorAll('[data-repair-models]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), {once: true});
  else initializeAll();
  document.addEventListener('pcb:repair-ready', () => initializeAll());
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
